import { type BrandZohoTypes } from "@elit-hair/brands";
import { t } from "i18next";

import { CallButton, CallButtonVariant } from "@/components/ui/call-button";
import { useCall } from "@/providers/hooks/use-call";
import type { ModuleType } from "@/types/zoho.types";
import { getPhoneFieldLabel, getPhoneNumbersFromRecord } from "@/utils/crm-module.utils";
import { formatPhoneNumber } from "@/utils/format-phone-number";

type LastCallPhoneNumbersProps = {
    record: BrandZohoTypes["Leads"] | BrandZohoTypes["Contacts"];
    moduleType: ModuleType;
    onCall: (phone: string) => void;
};

export function LastCallPhoneNumbers({ record, moduleType, onCall }: LastCallPhoneNumbersProps) {
    const { callButtonCooldown } = useCall();

    const phoneNumbers = getPhoneNumbersFromRecord(record, moduleType);

    if (!phoneNumbers.length) {
        return <div className="text-center text-muted-foreground py-2">{t("no_phone_numbers")}</div>;
    }
    return (
        <div className="flex flex-col gap-2 w-full mt-4">
            {phoneNumbers.map((phoneData, i) => {
                const label = getPhoneFieldLabel(phoneData.field);

                return (
                    <div
                        key={`${phoneData.number}-${i}`}
                        className="flex flex-row items-center justify-between w-full bg-muted p-2 rounded-md"
                    >
                        <div className="flex flex-col items-start w-full">
                            <p className="text-sm font-medium w-full text-left">{label}</p>
                            <p className="text-sm text-muted-foreground w-full text-left">
                                {formatPhoneNumber(phoneData.number)}
                            </p>
                        </div>
                        <CallButton
                            variant={CallButtonVariant.SQUARE}
                            size="md"
                            onCall={() => onCall(phoneData.number)}
                            disabled={callButtonCooldown}
                            tooltip={t("call_this_number")}
                        />
                    </div>
                );
            })}
        </div>
    );
}
